import React from 'react';

function ProductCard({title, slug, price, salePrice, thumbnail, webpThumbnail}) {
  const productURL = "/store/product/" + slug + "/";

  return (
    <li className="product-listing-card">
      {salePrice &&
        <span className="badge badge--sale">On Sale</span>
      }
      <div className="product-top">
        <a href={productURL} className="product-photo">
          <picture>
            <source srcSet={webpThumbnail} type="image/webp" loading="lazy" />
            <img height="220" width="220" src={thumbnail} alt={`Product image of ${title}`} loading="lazy" />
          </picture>
        </a>
          {/*
          {% with first_image=product.product_images.first %}
          {% if first_image.image %}{% thumbnail first_image.image 220x220 as image %}
          <picture>
            {% if image %}
            <source srcset="{{ image|webp_thumb_url }}" type="image/webp"{% if not forloop.first  %} loading="lazy"{% endif %} />
            {% endif %}
            <img height="{{ image.height }}" width="{{ image.width }}" src="{{ image.url }}" alt="{{ first_image.alt_text }}"{% if not forloop.first  %} loading="lazy"{% endif %} />
          </picture>
          {% endif %}
          {% endwith %}
          */}
        <h2 className="product-title"><a href={productURL}>{title}</a></h2>
      </div>
      <div className="product-bottom add-to-cart">     
        {salePrice ?
          (<div className="price">
            <strong className="sale-price">${salePrice}</strong> 
            <strike className="normal-price">{price}</strike> 
            <span className="pipe">|</span> 
            <span className="savings text-success">Save ###%</span>
          </div>)
        :
          <div className="price">${price}</div>
        }
       {/* 
        {% if product.goaa_live %}
          <a href="{{ product_url }}" class="btn btn-sm">{% trans "View More" %}</a>
        {% else %}
          <a href="#" class="btn btn-sm" data-add-to-cart="{{ product.id|stringformat:"d" }}">{% trans "Add to Cart" %}</a>
        {% endif %}
         */}
      </div>
    </li>
  )
}

export default ProductCard